import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { btnStyle } from "../../../theme";
import API from "../../../api";
import dayjs from "dayjs";
import { startToast, updateToastError, updateToastSuccess } from "../../../utils/notification-loading";

const itemStyle = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: 2,
  backgroundColor: "#2e2e2e",
  borderRadius: "15px",
  color: "#fff",
  p: 2,
  "& .MuiTypography-root": {
    fontSize: 20,
    fontWeight: 600,
  },
  "& .MuiTypography-root span": {
    fontWeight: 300,
    color: "#459095",
  },
};

const LicenseList = ({licenses = [], setLicenses}) => {
  const [codice, setCodice] = useState("");
  const [dealer, setDealer] = useState("");

  const handleAddLicense = () => {
    startToast();
    if(codice !== "" && dealer > 0) {
      API.AddLicense({codice: codice, dealer: dealer}).then((res) => {
        setLicenses((prev) => [...prev, {
          codiceAttivazione: codice,
          dataScadenza: res.data.dataScadenza,
          device_limit: res.data.device_limit,
          devices: [],
        }])
        updateToastSuccess("License added successfully");
        setCodice("");
        setDealer("");
      }).catch((err) => {
        updateToastError(err.response.data.err);
      })
    }
  }

  useEffect(() => {}, [licenses]);

  if(licenses.length === 0) {
    return (
      <Stack direction={"column"} spacing={3} width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"center"}>
        <Typography variant="h4">Insert your License and Dealer number</Typography>
        <Stack direction={"row"} spacing={2}>
          <TextField
            label= "License Code"
            placeholder="XXXX-XXXX-XXXX-XXXX-XXXX"
            value={codice}
            onChange={(e) => setCodice(e.target.value)}
            sx={{width: "80%"}}
            slotProps={{
              htmlInput: {
                onInput: (e) => {
                  let cleaned = e.target.value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
                  if (cleaned.length > 20) cleaned = cleaned.slice(0, 20);
                  const formatted = cleaned.match(/.{1,4}/g)?.join("-") || "";
                  e.target.value = formatted;
                }
              }
            }}
          />
          <TextField
            label= "Dealer ID"
            placeholder="1"
            value={dealer}
            onChange={(e) => setDealer(e.target.value)}
            sx={{width: "20%"}}
            type="number"
          />
        </Stack>
        <Button
          sx={{...btnStyle, width: "fit-content"}}
            onClick={handleAddLicense}
        >ACTIVATE</Button>
      </Stack>
    )
  } else {
    return (
      <Stack direction={"row"} spacing={2} height={"100%"}>
        <Stack direction={"column"} spacing={2} width={"30%"} height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography sx={{fontSize: 20}}>Add a new License</Typography>
          <TextField
            label="License Code"
            placeholder="XXXX-XXXX-XXXX-XXXX-XXXX"
            value={codice}
            required
            onChange={(e) => setCodice(e.target.value)}
            fullWidth
            slotProps={{
              htmlInput: {
                onInput: (e) => {
                  let cleaned = e.target.value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
                  if (cleaned.length > 20) cleaned = cleaned.slice(0, 20);
                  const formatted = cleaned.match(/.{1,4}/g)?.join("-") || "";
                  e.target.value = formatted;
                }
              }
            }}
          />
          <TextField
            label="Dealer Number"
            placeholder="1"
            required
            value={dealer}
            onChange={(e) => setDealer(e.target.value)}
            fullWidth
            type="number"
          />
          <Button
            disabled={!codice || !dealer}
            sx={{...btnStyle, width: "fit-content"}}
            onClick={handleAddLicense}
          >ACTIVATE</Button>
        </Stack>
        <Box sx={{
          width: "70%",
          height: "100%",
          overflow: "auto",
          "&::-webkit-scrollbar": {
            display: "none"
          },
          "scrollbarWidth": "none",
          "-ms-overflow-style": "none"
        }}>
          <Stack direction={"column"} spacing={2}>
            {licenses.map((license) => (
              <Box sx={itemStyle}>
                <Typography>License code: <span>{license.codiceAttivazione}</span></Typography>
                <Typography>Expires date: <span>{dayjs(license.dataScadenza).format("YYYY/MM/DD")}</span></Typography>
                <Typography>Number of existing LECS: <span>{license?.devices?.length ?? 0}/{license.device_limit}</span></Typography>
                <Typography>Serial Numbers: <span>{license?.devices?.map(d => d.matricola)?.join(", ") ?? ""}</span></Typography>
              </Box>
            ))}
          </Stack>
        </Box>
      </Stack>
    )
  }
};

export default LicenseList;